var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHornIcon = function SvgHornIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9C5.33333 9 7.16667 9 9 9C11 9 13.3333 7.33333 16 4V19C13.3333 15.6667 11 14 9 14C7.16667 14 5.33333 14 3.5 14C2.11929 14 1 12.8807 1 11.5C1 10.1193 2.11929 9 3.5 9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14L6 20H10L8 14H4Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16C20.0858 13.9142 20.0858 10.0858 18 8M20 19C23.9855 15.0145 24.0077 9.00768 20 5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export { SvgHornIcon as ReactComponent };
export default __webpack_public_path__ + "assets/167ad527.svg";